<template>
  <div class="content background1">
    <div class="pageTitle"><p>{{ $t('label_711') }}</p></div>
    <div class="tableBox3">
      <div class="tableMes">
        <div class="table">
          <div class="btnBox2">
            <!-- <div class="addButton" @click="insert1"><i class="el-icon-circle-plus"></i>{{ $t('btn_14') }}</div> -->
            <!-- <div class="editButton" @click="update1"><i class="el-icon-edit"></i>{{ $t('btn_15') }}</div> -->
            <!-- <div class="delButton" @click="del1"><i class="el-icon-delete-solid"></i>{{ $t('btn_16') }}</div> -->
            <!-- <div class="selectText" style="width: 90px;line-height: 40px; text-align: right; padding-right: 10px; font-weight: 600; font-size: 14px; margin-top: 8px;">
              <p>{{$t('label_765')}}</p>
            </div>
            <div class="mesInput" style="margin-top: 8px; margin-right: 5px;">
              <el-date-picker v-model="startDay" style="width: 150px;" value-format="yyyy-MM-dd" type="date"></el-date-picker>
            </div> -->
            <div class="addButton" @click="rest" v-if="MenuRoleList.indexOf('95')>=0"><i
              class="el-icon-date"></i>{{ $t('btn_59') }}
            </div>
          </div>
          <el-table
            ref="singleTable"
            :data="tableData1"
            highlight-current-row
            @current-change="handleCurrentChange1"
            border
            style="width: 100%;"
            height="700"
            :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
            <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index"
                             :index="getIndex" width="50">
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('label_297')" align="center">
            </el-table-column>
            <el-table-column
              prop="remarks"
              :label="$t('btn_29')" align="center">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="tableBox4">
      <div class="tableMes">
        <div class="table">
          <div class="btnBox2">
            <div class="addButton" @click="insert2" v-if="MenuRoleList.indexOf('96')>=0"><i
              class="el-icon-circle-plus"></i>{{ $t('btn_14') }}
            </div>
            <div class="editButton" @click="update2" v-if="MenuRoleList.indexOf('97')>=0"><i
              class="el-icon-edit"></i>{{ $t('btn_15') }}
            </div>
            <div class="delButton" @click="del2" v-if="MenuRoleList.indexOf('98')>=0"><i
              class="el-icon-delete-solid"></i>{{ $t('btn_16') }}
            </div>
          </div>
          <el-table
            :data="tableData2"
            highlight-current-row
            @current-change="handleCurrentChange2"
            border
            style="width: 100%;"
            height="90%"
            :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
            <el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index"
                             :index="getIndex" width="50">
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('label_297')" align="center">
            </el-table-column>
            <el-table-column
              prop="type"
              :label="$t('label_120')"
              align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.type == 0">{{ $t('label_285') }}</span>
                <span v-if="scope.row.type == 1">{{ $t('label_288') }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="beginTime" align="center"
              :label="$t('label_580')">
            </el-table-column>
            <el-table-column
              prop="endTime" align="center"
              :label="$t('label_585')">
            </el-table-column>
            <!-- <el-table-column
              prop="planYield" align="center"
              label="计划产量">
            </el-table-column> -->
          </el-table>
        </div>
      </div>
    </div>
    <!--<div class="tableBox5">
      <div class="tableMes">
        <div class="table">
          <div class="btnBox2">
            <div class="addButton" @click="insert3"><i class="el-icon-circle-plus"></i>新增</div>
            <div class="editButton" @click="update3"><i class="el-icon-edit"></i>编辑</div>
            <div class="delButton" @click="del3"><i class="el-icon-delete-solid"></i>删除</div>
          </div>
          <el-table
            :data="tableData3"
			highlight-current-row
			@current-change="handleCurrentChange3"
            border
            style="width: 100%;"
			height="360"
            :header-cell-style="{'background-color': '#457bff','color': '#ffffff',}">
            <el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex" width="50">
            </el-table-column>
            <el-table-column
              prop="beginTime"
              label="开始时间" align="center">
            </el-table-column>
            <el-table-column
              prop="endTime"
              label="结束时间" align="center">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>-->
    <el-dialog
      :title="$t('btn_14')"
      :visible.sync="unInsertVisible1" append-to-body
      :close-on-click-modal='false'
      width="30%"
      top="10%"
      :before-close="handleClose" custom-class="dialogBox">
      <div style="width: 310px; margin: 0 auto;">
        <div class="dialogMes">
          <p>{{ $t('label_297') }}</p>
          <div class="mesInput">
            <el-input v-model="workDataList.name"></el-input>
          </div>
        </div>
        <div class="dialogMes">
          <p>{{ $t('btn_29') }}</p>
          <div class="mesInput">
            <el-input v-model="workDataList.remarks"></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
	    <div class="chooseButton sendButton" @click="unInsertSend1"><i class="el-icon-s-promotion"></i>{{ $t('btn_14') }}</div>
	  </span>
    </el-dialog>
    <el-dialog
      :title="$t('btn_15')"
      :visible.sync="unUpdateVisible1" append-to-body
      :close-on-click-modal='false'
      width="30%"
      top="10%"
      :before-close="handleClose" custom-class="dialogBox">
      <div style="width: 310px; margin: 0 auto;">
        <div class="dialogMes">
          <p>{{ $t('label_297') }}</p>
          <div class="mesInput">
            <el-input v-model="workDataList.name"></el-input>
          </div>
        </div>
        <div class="dialogMes">
          <p>{{ $t('btn_29') }}</p>
          <div class="mesInput">
            <el-input v-model="workDataList.remarks"></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
	    <div class="chooseButton sendButton" @click="unUpdateSend1"><i class="el-icon-s-promotion"></i>{{ $t('btn_15') }}</div>
	  </span>
    </el-dialog>
    <el-dialog
      :title="$t('btn_16')"
      :visible.sync="unDeleteVisible1" append-to-body
      :close-on-click-modal='false'
      width="30%"
      top="10%"
      center
      :before-close="handleClose" custom-class="dialogBox">
      <p style="text-align: center;font-size: 16px">{{ $t('msg_66') }}?</p>
      <div class="btnBox2" style="width: 100%;justify-content: center;">
        <div class="editButton" @click="unDeleteVisible1 = false">{{ $t('btn_1') }}</div>
        <div class="delButton" @click="unDeleteSend1"><i class="el-icon-delete-solid"></i>{{ $t('btn_16') }}</div>
      </div>
    </el-dialog>
    <el-dialog
      :title="$t('btn_59')"
      :visible.sync="restVisible" append-to-body
      :close-on-click-modal='false'
      width="80%"
      top="5%"
      :before-close="handleClose" custom-class="dialogBox">
      <div style="height:620px;">
        <calendar ref="calendarDisplay" @saveRest="saveRest" :restId="restId" :showButton="false" :startDay="startDay"
                  :calendarData="calendarData"
                  @yearChange="yearChange"
                  @selectRest="selectRest"></calendar>
      </div>
    </el-dialog>

    <el-dialog
      v-loading="saveLoading"
      :title="$t('btn_14')"
      :visible.sync="unInsertVisible2" append-to-body
      :close-on-click-modal='false'
      width="30%"
      top="10%"
      :before-close="handleClose" custom-class="dialogBox">
      <div style="width: 310px; margin: 0 auto;">
        <div class="dialogMes">
          <span style="color: #ff0000;margin-top: 10px;">*</span>
          <p>{{ $t('label_297') }}</p>
          <div class="mesInput">
            <el-input v-model="workTimeList.name" clearable></el-input>
          </div>
        </div>
        <div class="dialogMes">
          <span style="color: #ff0000;margin-top: 10px;">*</span>
          <p style="width: 90px;">{{ $t('label_120') }}</p>
          <div class="mesInput">
            <el-select v-model="workTimeList.type" filterable :placeholder="$t('input_65')">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="dialogMes">
          <span style="color: #ff0000;margin-top: 10px;">*</span>
          <p style="width: 90px;">{{ $t('label_580') }}</p>
          <div class="mesInput">
            <el-time-picker style="width: 210px;" format='HH:mm' value-format='HH:mm:00'
                            v-model="workTimeList.beginTime" :placeholder="$t('input_91')"></el-time-picker>
          </div>
        </div>
        <div class="dialogMes">
          <span style="color: #ff0000;margin-top: 10px;">*</span>
          <p>{{ $t('label_585') }}</p>
          <div class="mesInput">
            <el-time-picker style="width: 210px;" format='HH:mm' value-format='HH:mm:00' v-model="workTimeList.endTime"
                            :placeholder="$t('input_91')"></el-time-picker>
          </div>
        </div>
        <!-- <div class="dialogMes">
          <p>计划产量</p>
          <div class="mesInput">
            <el-input v-model="workTimeList.planYield"></el-input>
          </div>
        </div> -->
        <div class="dialogMes">
          <div class="mesInput" style="text-align: right">
            <el-radio v-model="workTimeList.overDay" label="0">{{ $t('label_125') }}</el-radio>
            <el-radio v-model="workTimeList.overDay" label="1">{{ $t('label_130') }}</el-radio>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
	    <div class="chooseButton sendButton" @click="unInsertSend2"><i class="el-icon-s-promotion"></i>{{ $t('btn_13') }}</div>
	  </span>
    </el-dialog>

    <el-dialog
      v-loading="saveLoading"
      :title="$t('btn_15')"
      :visible.sync="unUpdateVisible2" append-to-body
      :close-on-click-modal='false'
      width="30%"
      top="10%"
      :before-close="handleClose" custom-class="dialogBox">
      <div style="width: 310px; margin: 0 auto;">
        <div class="dialogMes">
          <span style="color: #ff0000;margin-top: 10px;">*</span>
          <p style="width: 90px;">{{ $t('label_297') }}</p>
          <div class="mesInput">
            <el-input v-model="workTimeList.name" clearable></el-input>
          </div>
        </div>
        <div class="dialogMes">
          <span style="color: #ff0000;margin-top: 10px;">*</span>
          <p style="width: 90px;">{{ $t('label_120') }}</p>
          <div class="mesInput">
            <el-select v-model="workTimeList.type">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="dialogMes">
          <span style="color: #ff0000;margin-top: 10px;">*</span>
          <p>{{ $t('label_580') }}</p>
          <div class="mesInput">
            <el-time-picker style="width: 210px;" format='HH:mm:ss' value-format='HH:mm:ss'
                            v-model="workTimeList.beginTime" :placeholder="$t('input_91')"></el-time-picker>
          </div>
        </div>
        <div class="dialogMes">
          <span style="color: #ff0000;margin-top: 10px;">*</span>
          <p>{{ $t('label_585') }}</p>
          <div class="mesInput">
            <el-time-picker style="width: 210px;" format='HH:mm:ss' value-format='HH:mm:ss'
                            v-model="workTimeList.endTime" :placeholder="$t('input_91')"></el-time-picker>
          </div>
        </div>
        <!-- <div class="dialogMes">
          <p>计划产量</p>
          <div class="mesInput">
            <el-input v-model="workTimeList.planYield"></el-input>
          </div>
        </div> -->
        <div class="dialogMes">
          <div class="mesInput" style="text-align: right">
            <el-radio v-model="workTimeList.overDay" label="0">{{ $t('label_125') }}</el-radio>
            <el-radio v-model="workTimeList.overDay" label="1">{{ $t('label_130') }}</el-radio>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
	    <div class="chooseButton sendButton" @click="unUpdateSend2"><i class="el-icon-s-promotion"></i>{{ $t('btn_13') }}</div>
	  </span>
    </el-dialog>

    <el-dialog
      :title="$t('btn_16')"
      :visible.sync="unDeleteVisible2" append-to-body
      :close-on-click-modal='false'
      width="30%"
      top="10%"
      center
      :before-close="handleClose" custom-class="dialogBox">
      <p style="text-align: center;font-size: 16px">{{ $t('msg_66') }}?</p>
      <div class="btnBox2" style="width: 100%;justify-content: center;">
        <div class="editButton" @click="unDeleteVisible2 = false" style="">{{ $t('btn_1') }}</div>
        <div class="delButton" @click="unDeleteSend2"><i class="el-icon-delete-solid"></i>{{ $t('btn_16') }}</div>
      </div>
    </el-dialog>

    <el-dialog
      v-loading="saveLoading"
      :title="$t('btn_14')"
      :visible.sync="unInsertVisible3" append-to-body
      :close-on-click-modal='false'
      width="30%"
      top="10%"
      :before-close="handleClose" custom-class="dialogBox">
      <div style="width: 310px; margin: 0 auto;">
        <div class="dialogMes">
          <p>{{ $t('label_580') }}</p>
          <div class="mesInput">
            <el-time-picker style="width: 210px;" format='HH:mm' value-format='HH:mm:00'
                            v-model="timeDivisionList.beginTime" :placeholder="$t('input_91')"></el-time-picker>
          </div>
        </div>
        <div class="dialogMes">
          <p>{{ $t('label_585') }}</p>
          <div class="mesInput">
            <el-time-picker style="width: 210px;" format='HH:mm' value-format='HH:mm:00'
                            v-model="timeDivisionList.endTime" :placeholder="$t('input_91')"></el-time-picker>
          </div>
        </div>
        <div class="dialogMes">
          <div class="mesInput" style="text-align: right">
            <el-radio v-model="timeDivisionList.overDay" label="0">{{ $t('label_125') }}</el-radio>
            <el-radio v-model="timeDivisionList.overDay" label="1">{{ $t('label_130') }}</el-radio>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
	    <div class="chooseButton sendButton" @click="unInsertSend3"><i class="el-icon-s-promotion"></i>{{ $t('btn_13') }}</div>
	  </span>
    </el-dialog>

    <el-dialog
      v-loading="saveLoading"
      :title="$t('btn_15')"
      :visible.sync="unUpdateVisible3" append-to-body
      width="30%"
      top="10%"
      :close-on-click-modal='false'
      :before-close="handleClose" custom-class="dialogBox">
      <div style="width: 310px; margin: 0 auto;">
        <div class="dialogMes">
          <p>{{ $t('label_580') }}</p>
          <div class="mesInput">
            <el-time-picker style="width: 210px;" format='HH:mm' value-format='HH:mm:00'
                            v-model="timeDivisionList.beginTime" :placeholder="$t('input_91')"></el-time-picker>
          </div>
        </div>
        <div class="dialogMes">
          <p>{{ $t('label_585') }}</p>
          <div class="mesInput">
            <el-time-picker style="width: 210px;" format='HH:mm' value-format='HH:mm:00'
                            v-model="timeDivisionList.endTime" :placeholder="$t('input_91')"></el-time-picker>
          </div>
        </div>
        <div class="dialogMes">
          <div class="mesInput" style="text-align: right">
            <el-radio v-model="timeDivisionList.overDay" label="0">{{ $t('label_125') }}</el-radio>
            <el-radio v-model="timeDivisionList.overDay" label="1">{{ $t('label_130') }}</el-radio>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
	    <div class="chooseButton sendButton" @click="unUpdateSend3"><i class="el-icon-s-promotion"></i>{{ $t('btn_13') }}</div>
	  </span>
    </el-dialog>

    <el-dialog
      :title="$t('btn_16')"
      :visible.sync="unDeleteVisible3" append-to-body
      width="30%"
      top="10%"
      :close-on-click-modal='false'
      center
      :before-close="handleClose" custom-class="dialogBox">
      <p style="text-align: center;font-size: 16px">{{ $t('msg_66') }}?</p>
      <span slot="footer" class="dialog-footer">
		<div class="btnBox3" style="width: 100%;">
		  <div class="cancelButton" @click="unDeleteVisible3 = false" style="">{{ $t('btn_1') }}</div>
		  <div class="delButton" @click="unDeleteSend3"><i class="el-icon-delete-solid"></i>{{ $t('btn_16') }}</div>
		</div>
	  </span>
    </el-dialog>
  </div>
</template>

<script>
import "@/assets/css/map/map.css"
import Page from "@/components/common/page";
import TimePage from "@/assets/js/timePage/timePage.js";
import calendar from "@/components/list/calendarRest/calendar";
import utils from '@/utils/utils'
import moment from "moment/moment";

export default {
  name: 'timePage',
  components: {
    Page,
    calendar,
  },
  data() {
    return {
      saveLoading: false,
      model: [],
      MenuRoleList: [],
      unDetailList: [],
      year: '',
      calendarData: [],
      pageNum: 1,
      pageSize: 10,
      pageCount: 0,
      options: [{
        value: '0',
        label: this.$t('label_285')
      }, {
        value: '1',
        label: this.$t('label_288')
      }],
      unInsertVisible1: false,
      unUpdateVisible1: false,
      unDeleteVisible1: false,
      unInsertVisible2: false,
      unUpdateVisible2: false,
      unDeleteVisible2: false,
      unInsertVisible3: false,
      unUpdateVisible3: false,
      unDeleteVisible3: false,
      restVisible: false,
      stationList: [{
        label: this.$t('label_272'),
        value: '0'
      }],
      workDataList: {
        id: '',
        name: '',
        remarks: '',
      },
      workTimeList: {
        id: '',
        workRestId: '',
        name: '',
        type: '',
        beginTime: '',
        endTime: '',
        planYield: '0',
        overDay: '0',
      },
      timeDivisionList: {
        id: '',
        workRestId: '',
        beginTime: '',
        endTime: '',
        overDay: '0',
      },
      tableData1: [],
      tableData2: [],
      tableData3: [],
      tableInfo1: {},
      tableInfo2: {},
      tableInfo3: {},
      ajaxFlag: true,
      startDay: moment().format('YYYY') + '-01-01',
      restId: ''
    }
  },
  methods: {
    yearChange(year) {
      this.startDay = year
    },
    handler() {

    },
    getIndex(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    detailPop() {
      this.unDetailVisible = true
    },
    undetailSend() {
      console.log(this.unDetailList);
      this.unDetailVisible = false;
    },
    insert1() {
      this.unInsertVisible1 = true;
      this.workDataList.name = '';
      this.workDataList.remarks = '';
    },
    update1() {
      if (Object.keys(this.tableInfo1).length > 0) {
        this.unUpdateVisible1 = true;
        this.workDataList.id = this.tableInfo1.id;
        this.workDataList.name = this.tableInfo1.name;
        this.workDataList.remarks = this.tableInfo1.remarks;
      } else {
        utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
      }
    },
    del1() {
      if (Object.keys(this.tableInfo1).length > 0) {
        this.unDeleteVisible1 = true;
        this.workDataList.id = this.tableInfo1.id;
      } else {
        utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
      }
    },
    rest() {
      this.restVisible = true;
      this.restId = this.tableInfo1.id;
      this.$nextTick(() => {
        this.year = this.$refs.calendarDisplay.year;
        let param = {
          restId: this.restId,
          startDay: this.startDay
        }
        this.selectRestList(param);
      })
    },
    selectRestList(param) {
      TimePage.selectRestList(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.calendarData = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    selectRest(val) {
      let param = {
        restId: this.restId,
        startDay: val.year + '-01-01'
      }
      TimePage.selectRestList(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.calendarData = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    saveRest(param) {
      TimePage.saveMaintainRest(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.restVisible = false;
          this.$message({
            message: this.$t('msg_21'),
            type: 'success'
          });
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    insert2() {
      this.ajaxFlag = true;
      this.unInsertVisible2 = true;
      this.workTimeList.name = '';
      this.workTimeList.type = this.options[0].value;
      this.workTimeList.beginTime = '';
      this.workTimeList.endTime = '';
      this.workTimeList.planYield = '0';
    },
    update2() {
      this.ajaxFlag = true;
      if (Object.keys(this.tableInfo2).length > 0) {
        this.unUpdateVisible2 = true;
        this.workTimeList.id = this.tableInfo2.id;
        this.workTimeList.name = this.tableInfo2.name;
        this.workTimeList.type = this.tableInfo2.type.toString();
        this.workTimeList.beginTime = this.tableInfo2.beginTime;
        this.workTimeList.endTime = this.tableInfo2.endTime;
        this.workTimeList.planYield = this.tableInfo2.planYield.toString();
        this.workTimeList.overDay = this.tableInfo2.overDay.toString();
      } else {
        utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
      }
    },
    del2() {
      if (Object.keys(this.tableInfo2).length > 0) {
        this.unDeleteVisible2 = true;
        this.workTimeList.id = this.tableInfo2.id;
      } else {
        utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
      }
    },
    insert3() {
      this.unInsertVisible3 = true;
      this.timeDivisionList.beginTime = '';
      this.timeDivisionList.endTime = '';
      this.timeDivisionList.type = this.options[0].value;
    },
    update3() {
      if (Object.keys(this.tableInfo3).length > 0) {
        this.unUpdateVisible3 = true;
        this.timeDivisionList.id = this.tableInfo3.id;
        this.timeDivisionList.beginTime = this.tableInfo3.beginTime;
        this.timeDivisionList.endTime = this.tableInfo3.endTime;
        this.timeDivisionList.overDay = this.tableInfo3.overDay.toString();
      } else {
        utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
      }
    },
    del3() {
      if (Object.keys(this.tableInfo3).length > 0) {
        this.unDeleteVisible3 = true;
        this.timeDivisionList.id = this.tableInfo3.id;
      } else {
        utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
      }
    },
    handleClose() {
      this.unDetailList = [];
      this.unInsertVisible1 = false;
      this.unUpdateVisible1 = false;
      this.unDeleteVisible1 = false;
      this.restVisible = false;
      this.unInsertVisible2 = false;
      this.unUpdateVisible2 = false;
      this.unDeleteVisible2 = false;
      this.unInsertVisible3 = false;
      this.unUpdateVisible3 = false;
      this.unDeleteVisible3 = false;
      this.startDay = moment().format('YYYY') + '-01-01'
    },
    searchPage() {
      this.workRest();
    },
    search() {
      this.searchPage();
    },
    workRest() {
      TimePage.workRest().then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.tableData1 = data.data;
          this.setCurrent(this.tableData1[0]);
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    workRestTime(param) {
      TimePage.workRestTime(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.tableData2 = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    timeDivision(param) {
      TimePage.timeDivision(param).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.tableData3 = data.data;
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    unInsertSend1() {
      TimePage.insert1(this.workDataList).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.unInsertVisible1 = false;
          this.search({
            pageNum: this.pageNum,
            pageSize: this.pageSize
          });
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    unUpdateSend1() {
      TimePage.update1(this.workDataList).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.unUpdateVisible1 = false;
          this.search({
            pageNum: this.pageNum,
            pageSize: this.pageSize
          });
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    unDeleteSend1() {
      TimePage.del1(this.workDataList.id).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.unDeleteVisible1 = false;
          this.search({
            pageNum: this.pageNum,
            pageSize: this.pageSize
          });
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    unInsertSend2() {
      this.saveLoading = true;
      if (utils.isEmpty(this.workTimeList.name)) {
        utils.messageAlert(this.$t('msg_30'), this.$t('label_358'), this.$t('label_100'))
        this.saveLoading = false;
        return false;
      }
      if (utils.isEmpty(this.workTimeList.beginTime)) {
        utils.messageAlert(this.$t('msg_40'), this.$t('label_358'), this.$t('label_100'))
        this.saveLoading = false;
        return false;
      }
      if (utils.isEmpty(this.workTimeList.endTime)) {
        utils.messageAlert(this.$t('msg_41'), this.$t('label_358'), this.$t('label_100'))
        this.saveLoading = false;
        return false;
      }
      // if (utils.isEmpty(this.workTimeList.planYield)) {
      //     utils.tipsAlert("计划产量不能为空");
      //     return false;
      // }
      if (this.ajaxFlag) {
        this.ajaxFlag = false;
        TimePage.insert2(this.workTimeList).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.unInsertVisible2 = false;
            // this.search({
            // 	pageNum: this.pageNum,
            // 	pageSize: this.pageSize
            // });
            this.workRestTime(this.workTimeList.workRestId);
          } else {
            utils.messageAlert(this.$t('msg_132'), this.$t('label_358'), this.$t('label_100'))
          }
          this.saveLoading = false;
          this.ajaxFlag = true;
        }).catch((response) => {
          console.log(response)
          this.saveLoading = false;
          this.ajaxFlag = true;
        })
      }

    },
    unUpdateSend2() {
      this.saveLoading = true;
      if (utils.isEmpty(this.workTimeList.name)) {
        utils.messageAlert(this.$t('msg_30'), this.$t('label_358'), this.$t('label_100'))
        this.saveLoading = false;
        return false;
      }
      if (utils.isEmpty(this.workTimeList.beginTime)) {
        utils.messageAlert(this.$t('msg_40'), this.$t('label_358'), this.$t('label_100'))
        this.saveLoading = false;
        return false;
      }
      if (utils.isEmpty(this.workTimeList.endTime)) {
        utils.messageAlert(this.$t('msg_41'), this.$t('label_358'), this.$t('label_100'))
        this.saveLoading = false;
        return false;
      }
      // if (utils.isEmpty(this.workTimeList.planYield)) {
      //     utils.tipsAlert("计划产量不能为空");
      //     return false;
      // }
      if (this.ajaxFlag) {
        this.ajaxFlag = false;
        TimePage.update2(this.workTimeList).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.unUpdateVisible2 = false;
            this.$message({
              message: this.$t('msg_23'),
              type: 'success'
            });
            // this.search({
            // 	pageNum: this.pageNum,
            // 	pageSize: this.pageSize
            // });
            this.workRestTime(this.workTimeList.workRestId);
          } else {
            utils.messageAlert(this.$t('msg_132'), this.$t('label_358'), this.$t('label_100'))
          }
          this.saveLoading = false;
          this.ajaxFlag = true;
        }).catch((response) => {
          console.log(response)
          this.saveLoading = false;
          this.ajaxFlag = true;
        })
      }

    },
    unDeleteSend2() {
      console.log(this.workTimeList.id);
      TimePage.del2(this.workTimeList.id).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.unDeleteVisible2 = false;
          // this.search({
          // 	pageNum: this.pageNum,
          // 	pageSize: this.pageSize
          // });
          this.workRestTime(this.workTimeList.workRestId);
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    unInsertSend3() {
      this.saveLoading = true;
      TimePage.insert3(this.timeDivisionList).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.unInsertVisible3 = false;
          // this.search({
          // 	pageNum: this.pageNum,
          // 	pageSize: this.pageSize
          // });
          this.timeDivision(this.timeDivisionList.workRestId);
        }
        this.saveLoading = false;
      }).catch((response) => {
        console.log(response)
        this.saveLoading = false;
      })
    },
    unUpdateSend3() {
      this.saveLoading = true;
      TimePage.update3(this.timeDivisionList).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.unUpdateVisible3 = false;
          // this.search({
          // 	pageNum: this.pageNum,
          // 	pageSize: this.pageSize
          // });
          this.timeDivision(this.timeDivisionList.workRestId);
        }
        this.saveLoading = false;
      }).catch((response) => {
        console.log(response)
        this.saveLoading = false;
      })
    },
    unDeleteSend3() {
      TimePage.del3(this.timeDivisionList.id).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.unDeleteVisible3 = false;
          // this.search({
          // 	pageNum: this.pageNum,
          // 	pageSize: this.pageSize
          // });
          this.timeDivision(this.timeDivisionList.workRestId);
        }
      }).catch((response) => {
        console.log(response)
      })
    },
    handleCurrentChange1(info) {
      this.tableInfo1 = info;
      this.workTimeList.workRestId = this.tableInfo1.id;
      this.timeDivisionList.workRestId = this.tableInfo1.id;
      this.workRestTime(this.workTimeList.workRestId);
      // this.timeDivision(this.timeDivisionList.workRestId);
    },
    setCurrent(row) {
      this.$refs.singleTable.setCurrentRow(row);
      this.workTimeList.workRestId = row.id;
      this.timeDivisionList.workRestId = row.id;
      this.workRestTime(this.workTimeList.workRestId);
      // this.timeDivision(this.timeDivisionList.workRestId);
    },
    handleCurrentChange2(info) {
      this.tableInfo2 = info;
    },
    handleCurrentChange3(info) {
      this.tableInfo3 = info;
    },
    selectParamById(id) {
      TimePage.selectParamById(id).then((response) => {
        const data = response.data;
        if (data.code == "1") {
          this.startDay = data.data.value;
        }
      }).catch((response) => {
        console.log(response)
      })
    }
  },
  created() {
    this.search();
    // this.selectParamById(1);
    this.MenuRoleList = this.$store.getters.getMenu;
  }
}
</script>

<style>
.btnBox2 .addButton {

  margin-left: 0px;

}
</style>



// WEBPACK FOOTER //
// src/pages/basic/timePage.vue